import * as React from "react";
import { Context } from "./_context";
export const VigationCopyIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19.5 6.5A2.5 2.5 0 0 1 22 9v11.5a2.5 2.5 0 0 1-2.5 2.5H10a2.5 2.5 0 0 1-2.5-2.5V9A2.5 2.5 0 0 1 10 6.5h9.5Zm-9 13.5H19V9.5h-8.5V20Zm5.75-19a.25.25 0 0 1 .25.25v2.5a.25.25 0 0 1-.25.25H5v13.25a.25.25 0 0 1-.25.25h-2.5a.25.25 0 0 1-.25-.25V3.5A2.5 2.5 0 0 1 4.5 1h11.75Z", fill: "currentColor" }));
  return iconset[size];
};
VigationCopyIcon.iconId = "5dkChU";
